import React from 'react'
import SectionHeading from '../HomePage/SectionHeading'
import SectionHeadingWrapper from '../HomePage/SectionHeadingWrapper'

const WhyChooseUs = () => {
    const services = [
        {
            title: 'Custom List Creation',
            description:
                "We don't believe in one-size-fits-all. Whether you need absentee owner lists, high-equity properties, unknown equity, vacant properties, related party transactions, or trusts, we've got you covered.",
            image: '/assets/premium-lead-lists/Image-1.png',
            imageAlt:
                'A hand is placing the last white puzzle piece into a gap in a gray puzzle.',
            imageTitle: 'Finding the missing piece.',
        },
        {
            title: 'Focused Targeting',
            description:
                'We refine your list to pinpoint the most motivated sellers, increasing your chances of making successful deals. Our precise targeting means you get the best prospects right from the start.',
            image: '/assets/premium-lead-lists/Image-2.png',
            imageAlt: 'Two groups of people are meeting at a white table.',
            imageTitle: 'Business people shaking hands in a meeting.',
        },
        {
            title: 'Personalized Approach',
            description:
                'We take the time to understand your unique investment goals. By discussing your criteria in detail, we ensure that the lists we provide are perfectly tailored to your needs.',
            image: '/assets/premium-lead-lists/Image-3.png',
            imageAlt:
                'An older woman speaking animatedly, gesturing with both hands across a wooden table to another woman.',
            imageTitle: 'Businesswoman leading a discussion in a meeting.',
        },
    ]

    return (
        <div className="max-w-5xl mx-auto md:p-8 px-2">
            <SectionHeadingWrapper>
                <SectionHeading>Why Choose Our Service?</SectionHeading>
            </SectionHeadingWrapper>
            <div className="grid grid-cols-1 md:gap-8 px-4 items-center">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className="flex items-center flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                        <img
                            src={service.image}
                            alt={service.imageAlt}
                            title={service.imageTitle}
                            className="w-full md:w-1/2"
                        />
                        <div
                            className={`md:w-1/2 order-first ${
                                (index + 1) % 2 === 1
                                    ? 'md:order-first'
                                    : 'md:order-last'
                            }`}>
                            <h3 className="md:text-3xl text-2xl font-bold text-orange-600 mb-2">
                                {service.title}
                            </h3>
                            <p className="text-gray-700 md:text-xl text-lg">
                                {service.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default WhyChooseUs
